import React from 'react';
import { Autocomplete, Box, Dialog, Grid, TextField, Typography } from '@mui/material';
import { translate } from 'react-jhipster';
import { Button } from 'reactstrap';

export const AddBuyerDialog = ({
  openAddBuyerModal,
  handleAddBuyerModal,
  testUser,
  getNameForBuyer,
  handleOnChangeAddBuyer,
  handleAddBuyerConfirm,
  selectedBuyer = null,
}) => {
  return (
    <Dialog onClose={handleAddBuyerModal} open={openAddBuyerModal}>
      <Box sx={{ p: 3, width: 300 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {translate('comexApp.quotation.assignBuyerToProceed')}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              options={testUser}
              getOptionLabel={getNameForBuyer}
              onChange={handleOnChangeAddBuyer}
              value={selectedBuyer}
              renderInput={params => <TextField {...params} label={translate('comexApp.quotation.chooseBuyer')} />}
            />
          </Grid>

          <Grid item xs={12} container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" onClick={handleAddBuyerModal}>
                {translate('comexApp.quotation.cancelBtnLabel')}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" onClick={handleAddBuyerConfirm}>
                {translate('comexApp.quotation.confirmButton')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
